import React from 'react'

const Footer = () => {
  return (
    <div className='bg-gray-200 flex '>
        <h1 className='text-2xl sm:text-3xl lg:text-4xl px-2 py-6'>
            Best<span className='font-bold'>Eats</span> </h1>
            <span className='px-2 py-6 text-xl font-semibold mt-3'>" Your ultimate food adventure awaits!" </span>
    </div>
  )
}

export default Footer